import React, { useRef, useState } from 'react';
import ImageExpand from '../ImageExpand';
import Asset from '../Asset';
import styles from './ModuleNavattic.module.scss';
import Modal from 'react-bootstrap/Modal';
import cx from 'clsx';
import useTranslation from 'next-translate/useTranslation';
import {
  getNavatticCookieConsentFromCookie,
  sendNavatticCookieConsentToIframe
} from '../../utils/navatticConsent';


const ModuleNavattic = (props) => {
  const { image, imageExpand, _id, navattic, title } = props
  const [expandImage, setExpandImage] = useState(false)
  const [isDesktop, setIsDesktop] = useState(true);
  const iframeSrc = navattic && navattic.match(/src="([^"]+)"/);
  const url = iframeSrc ? iframeSrc[1] : null;
  const { t } = useTranslation();
  const navatticConsentRef = useRef(null);

  React.useEffect(() => {
    navatticConsentRef.current = getNavatticCookieConsentFromCookie();
  }, []);

  const handleOpenDemo = () => {
    navatticConsentRef.current = getNavatticCookieConsentFromCookie();
    setExpandImage(true);
  };

  const handleIframeLoad = (e) => {
    sendNavatticCookieConsentToIframe(
      e.currentTarget,
      navatticConsentRef.current || getNavatticCookieConsentFromCookie()
    );
  };

  const handleExpandImage = (value, e) => {
    setExpandImage(false)
  }
  React.useEffect(() => {
    if (expandImage) {
      const navatticConetnt = document.querySelector('.modal-content')
      if (navatticConetnt) {
        navatticConetnt.style.height = "90%";
      }
    }
  }, [expandImage])
  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth > 1024);
    };

    checkScreenSize();

    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);
  if (!isDesktop) {
    return null;
  }
  return (
    <div data-testid="ModuleNavattic" className={styles.hideOnSmallScreen}>
      {image ? (
        <div className={imageExpand ? styles.navatticFrame : ""} onClick={handleOpenDemo}>
          <Asset {...image} />
        </div>
      ) : null}
      <div className={styles.contentWrapper}>
        <span>{title}</span>
        <button onClick={handleOpenDemo}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 19L18.5 12L7.5 5V19Z" fill="#1A1918" />
            <path d="M7.5 19L18.5 12L7.5 5V19Z" fill="#1A1918" />
          </svg>

          <span className={styles.startDemo}>{t('common:startdemo')}</span>
        </button>
      </div>
      {imageExpand &&
        <Modal
          show={expandImage}
          onHide={() => setExpandImage(false)}
          scrollable
          centered
          animation={false}
          className={styles.modalDialog}>
          <Modal.Body>
            <>
              <button type="button" className={cx(styles.imageExpand, styles.close)} onClick={(e) => handleExpandImage(false, e)} aria-label='Close demo'>
                <Asset url="/images/assets/icon-close-x.svg" title="Close image" isInlineSvg />
              </button>
              <iframe
                src={url}
                title="Navattic Demo"
                width="100%"
                height="100%"
                frameBorder="0"
                className={styles.navatiVideoPlayer}
                onLoad={handleIframeLoad}
              />

            </>
          </Modal.Body>
        </Modal>
      }
    </div>
  )
};
export default ModuleNavattic;